<template>
  <div class="create-video-element container-fluid"> 
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-left-1Point6Perc">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
            {{getCurrentlySelectedCourseObj.CourseTitle}}
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseCreateElementOverlay($event,false)">
              <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
            {{lessonObj.Title}}
          </div>    
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            <!-- Index -->
            Title
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="VideoTitleValue" :maxlength="maxLength">
              </div>
            </div>
          </div>
          
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Audio Url
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="AudioURLValue">
              </div>
            </div>
          </div>  
        </div>
  
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1"></div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Caption File
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="file" id="vttFile" accept=".vtt">
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Video Url(s)
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValue"></video-quality-control>
                <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>  
        </div>
        <div class="row vertical-align margin-bottom-1Point2Perc margin-top-1Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            File Url
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="file" id="toolkitfile" accept=".pdf">
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Link Text
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="VideoLinkTextValue">
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>  
        </div>
        <!-- Zuex Dropdown START -->
        <div class="row vertical-align margin-bottom-1Point5Perc" v-if="false">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Element Learning Type
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <!-- <option value=-1 disabled>Select Step to be added</option> -->
                <select class="form-control" v-model="elementLearningLevelObjValue">
                  <option value=-1>None</option>
                  <option v-for="learningLevelObj in getLearningLevelList" :key="learningLevelObj.LearningLevelId" :value="learningLevelObj.LearningLevelId">{{learningLevelObj.LearningLevelName}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6">
          </div>
        </div>
        <!-- Zuex Dropdown END -->

          <div class="row vertical-align margin-bottom-2Perc">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <div class="checkbox">
                  <label><input type="checkbox" value="true" v-model="VideoIncludeInProgress" disabled>Include In Progress</label>
                </div>
              </div>
            </div> 
          </div>
          <div class="row margin-bottom-2Perc">
            <div class="col-md-5 col-lg-5">
            </div>  
            <div class="col-md-2 col-lg-2">
              <!-- ToDo: Track this -->
              <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="CreateVideoElement">Create Video</button>
            </div>  
            <div class="col-md-5 col-lg-5">
            </div>
          </div>
          <div class="row">
          </div>         
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div> 
</template>
<script>
import { constants } from '@/utils/constants'
import { elementService } from '@/server-util/element-service'
import AlertBox from '@/components/AlertOverlay'
import VideoQualityControl from '@/components/VideoQualityControl'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['lessonObj'],
  name: 'create-video-element',
  created () {
    this.setModuleId()
    this.GetLearningLevels()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      disableInputBoxFor360And720: true,
      errorMsg: '',
      elementObj: {
        ModuleId: '',
        Title: '',
        Duration: '',
        Type: 0,
        VideoUrl: '',
        AudioUrl: '',
        Content: null,
        Index: null,
        RDType: null,
        IncludeInProgress: true,
        LinkText: '',
        FileUrl: null,
        ElemChallenge: null,
        learningLevelId: '',
        LowQualityVideoUrl: '',
        HDVideoUrl: ''
      },
      maxLength: constants.Element_Title_Step_Max_Length
    }
  },
  components: {
    'alert-box': AlertBox,
    'video-quality-control': VideoQualityControl
  },
  methods: {
    updateVideoQualityValue (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.elementObj.LowQualityVideoUrl = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.elementObj.VideoUrl = videoUrl
          if (this.elementObj.VideoUrl.trim().length === 0) {
            this.elementObj.LowQualityVideoUrl = ''
            this.elementObj.HDVideoUrl = ''
            this.disableInputBoxFor360And720 = true
          } else {
            this.disableInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.elementObj.HDVideoUrl = videoUrl
          break
      }
    },
    udpateCloseCreateElementOverlay: function (event) {
      this.$emit('openOverlay', false)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    chekcToolkitFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    checkVttFileExtesion: function (fileName) {
      var exts = ['.vtt']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    CreateVideoElement: function (event) {
      // alert(JSON.stringify(this.elementObj))
      var fileUrl = document.getElementById('toolkitfile').files[0]
      var vttFileUrl = document.getElementById('vttFile').files[0]
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (fileUrl === undefined && fileUrl === null) {
          fileUrl = null
        }
        if (vttFileUrl === undefined && vttFileUrl === null) {
          vttFileUrl = null
        }
        this.VideoDurationValue = parseInt(document.getElementById('videoTag').duration)
        const formData = new FormData()
        formData.append('ModuleId', this.elementObj.ModuleId)
        formData.append('Title', this.elementObj.Title)
        const videoUrl = this.elementObj.VideoUrl !== '' ? this.elementObj.VideoUrl.trim() : ''
        formData.append('VideoUrl', videoUrl)
        const hdVideoUrl = this.elementObj.HDVideoUrl !== '' ? this.elementObj.HDVideoUrl.trim() : ''
        formData.append('HDVideoUrl', hdVideoUrl)
        const lowVideoUrl = this.elementObj.LowQualityVideoUrl !== '' ? this.elementObj.LowQualityVideoUrl.trim() : ''
        formData.append('LowQualityVideoUrl', lowVideoUrl)
        const audioUrl = this.elementObj.AudioUrl !== '' ? this.elementObj.AudioUrl.trim() : null
        formData.append('AudioUrl', audioUrl)
        formData.append('VttFileInput', vttFileUrl)
        if (this.elementObj.Index !== null && this.elementObj.Index !== '') {
          formData.append('Index', parseInt(this.elementObj.Index))
        }
        formData.append('IncludeInProgress', this.elementObj.IncludeInProgress)
        formData.append('LinkText', this.elementObj.LinkText)
        formData.append('FileData', fileUrl)
        formData.append('LearningLevelId', this.elementObj.learningLevelId)
        formData.append('Duration', this.elementObj.Duration)
        var _this = this
        var storeObj = this.$store
        if (formData !== undefined || formData !== '' || formData !== undefined) {
          // AK: Start showing spinner (Course file)
          _this.$emit('showSpinner', true)
          elementService
            .createVideoElement(storeObj.state.access_token, formData)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // AK: Refresh Element List by emitting event (LessonListCreateElement option)
                  _this.$emit('refreshElementList', true)
                } else {
                  // AK: Hide Spinner
                  _this.$emit('showSpinner', false)
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected FormData is NULL hence declined CREATE VIDEO OPERATION'
          )
        }
      }
    },
    setModuleId: function () {
      this.elementObj.ModuleId = this.lessonObj.ModuleId
    },
    validateRequiredFieldBeforeSubmit: function () {
      var fileUrl = document.getElementById('toolkitfile').files[0]
      var vttFileUrl = document.getElementById('vttFile').files[0]
      if (this.VideoTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.AudioURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.AudioURLValue.trim()) || !dmAdminUtils.checkForAudioFileExtesion(this.AudioURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Audio url.'
        return false
      } else if (this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Video url.'
        return false
      } else if (this.VideoURLValue.trim().length === 0 || !dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim())) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Video url.'
        return false
      } else if (this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Video url.'
        return false
      } else if (vttFileUrl !== undefined && vttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('vttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for caption.'
        return false
      } else if (fileUrl !== undefined && fileUrl !== null) {
        if (
          !this.chekcToolkitFileExtesion(
            document.getElementById('toolkitfile').value
          )
        ) {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a .pdf file.'
          return false
        } else {
          if (
            this.elementObj.LinkText === null ||
            this.elementObj.LinkText === '' ||
            this.elementObj.LinkText === undefined
          ) {
            this.showAlertDialog = true
            this.errorMsg = 'Link text can\'t be empty.'
            return false
          }
        }
      } else if (this.elementObj.LinkText.trim().length !== 0 && (fileUrl === undefined || fileUrl === null)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a .pdf file or remove the link text.'
        return false
      }
      return true
    },
    GetLearningLevels: function () {
      // var _this = this
      var storeObj = this.$store
      elementService
      .getLearningLevels(storeObj.state.access_token)
      .then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // console.log('respond status', responseObj.data.CreatedTS)
          // this.learningLevelId = responseObj.data
          storeObj.state.learningLevelList = responseObj.data
        } else {
            //  Hide Spinner
            // _this.$emit('showSpinner', false)
          this.showAlertDialog = true
          this.errorMsg = 'Oops! Something went wrong. Please try again.'
        }
      }, errorObj => {
        //  Hide Spinner
        // _this.$emit('showSpinner', false)
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    }
  },
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    VideoTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    VideoIndexValue: {
      get: function () {
        return this.elementObj.Index
      },
      set: function (newValue) {
        if (newValue.trim() !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            if (parseInt(newValue) >= 1000) {
              this.errorMsg = 'Index should be less than 1000.'
              this.showAlertDialog = true
              this.elementObj.Index = null
            } else {
              this.elementObj.Index = parseInt(newValue)
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.elementObj.Index = null
          }
        } else {
          this.elementObj.Index = null
        }
      }
    },
    VideoDurationValue: {
      get: function () {
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    VideoURLValue: {
      get: function () {
        return this.elementObj.VideoUrl
      },
      set: function (newValue) {
        this.elementObj.VideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.elementObj.HDVideoUrl
      },
      set: function (newValue) {
        this.elementObj.HDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.elementObj.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.elementObj.LowQualityVideoUrl = newValue
      }
    },
    AudioURLValue: {
      get: function () {
        return this.elementObj.AudioUrl
      },
      set: function (newValue) {
        this.elementObj.AudioUrl = newValue
      }
    },
    VideoLinkTextValue: {
      get: function () {
        return this.elementObj.LinkText
      },
      set: function (newValue) {
        this.elementObj.LinkText = newValue
      }
    },
    VideoIncludeInProgress: {
      get: function () {
        return this.elementObj.IncludeInProgress
      },
      set: function (newValue) {
        this.elementObj.IncludeInProgress = newValue
      }
    },
    getVideoUrlValue: {
      get: function () {
        return this.elementObj.VideoUrl
      }
    },
    elementLearningLevelObjValue: {
      get: function () {
        console.log('Learning Object value', this.elementObj.learningLevelId)
        // return this.elementObj.learningLevelId
        return -1
      },
      set: function (newValue) {
        this.elementObj.learningLevelId = newValue
      }
    },
    getLearningLevelList: {
      get: function () {
        // console.log('Learning List ++', this.$store.learningLevelList)
        return this.$store.state.learningLevelList
      }}
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-1Point2Perc {
  margin-bottom: 1.2%;
}
.margin-bottom-1Point5Perc {
  margin-bottom: 1.5%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.margin-top-2Point5Perc {
  margin-top: 2.5%;
}
.margin-bottom-3Perc {
  margin-bottom: 3%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.border-red {
  border: 1px solid red;
}
.height-152point8px {
  height: 152.8px;
}
.background-color {
  background-color: rgba(238, 238, 238, 0.575);
}
.border-white {
    border:1px solid white;
}
.border-light-grey {
 border: 1px solid #d6d6d6;   
}
.text-vertical-center {
  text-align: center;
}
.padding-top-bottom-69px {
  padding: 69px 0;
}
.margin-bottom-2px {
  margin-bottom:2px;
}
.margin-bottom-4point5px {
  margin-bottom:4.5px;
}
.height-52px {
  height: 52px;
}
.padding-16px-0px {
  padding:16px 0px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
</style>


// WEBPACK FOOTER //
// src/components/CreateVideoElement.vue